export default {
  title: 'Aloita tilauksesi',
  title_confirm: 'Vahvista pakettisi',
  step: 'Vaihe {{current}}/{{total}}',
  subtitle: '{{name}} · 1 toimipiste',
  trial_badge: '{{days}} päivää ilmaiseksi',
  trial_headline: 'Ensimmäiset {{days}} päivää ilmaiseksi',
  then_price: 'Sen jälkeen {{price}} / kk per toimipiste · sis. sovellettavan veron',
  price_per_month: '{{price}} / kk',
  price_terms: 'Per toimipiste, laskutetaan kuukausittain · sis. sovellettavan veron',
  tier_upsell:
    'Kun sinulla on {{threshold}}+ aktiivista toimipistettä, kaikkien toimipisteidesi hinta laskee automaattisesti hintaan {{price}} / kk per toimipiste.',
  tier_active: 'Volyymihinta — {{threshold}}+ aktiivista toimipistettä',
  due_today: 'Erääntyy tänään',
  from_date: 'Alkaen {{date}}',
  no_charge_today: 'Sinua ei veloiteta tänään.',
  no_charge_until: 'Sinua ei veloiteta tänään. Peruuta ennen {{date}}, niin et maksa mitään.',
  active: '{{plan}} on käytössä tälle ravintolalle.',
  active_with_trial: '{{plan}} on käytössä tälle ravintolalle, ilmainen {{date}} asti.',
  terms:
    'Hyväksyn <a href="{{terms_url}}" target="_blank" rel="noreferrer">FoodAmigosin kumppanialustan ehdot</a>, mukaan lukien aktivoinnin, peruutuksen ja hyvitykset.',
  error: 'Ostoa ei voitu suorittaa. Yritä uudelleen.',
  loading: 'Tarkistetaan tämän ravintolan pakettia…',
  load_error: 'Tämän ravintolan pakettia ei voitu tarkistaa.',
  unavailable: 'Tämä tuote ei ole saatavilla tälle ravintolalle. Ota yhteyttä FoodAmigos-yhteyshenkilöösi.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Verkkotilaus',
          description: 'Suorat tilaukset ravintolan omilla brändätyillä verkkosivuilla',
        },
        reservations: {
          title: 'Pöytävaraukset',
          description: 'Vieraat varaavat pöydän suoraan verkossa',
        },
        marketing: {
          title: 'Markkinointipaketti',
          description: 'Tarjousten rakentaja, kanta-asiakaspisteohjelma ja tekoälyvastaukset Google-arvosteluihin',
        },
        pricing: {
          title: '0 % provisio, ei käyttöönottomaksua',
          description: 'Yksi lisenssi per toimipiste, laskutetaan kuukausittain',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'Ravintolan oma brändätty sovellus',
          description: 'App Storessa ja Google Playssa',
        },
        engagement: {
          title: 'Push-ilmoitukset ja kanta-asiakkuus',
          description: 'Tuo vieraat takaisin tarjouksilla ja pisteillä',
        },
        ordering: {
          title: 'Tilaaminen 0 % provisiolla',
          description: 'Suorat tilaukset suoraan sovelluksesta',
        },
        apple: {
          title: 'Apple Developer -tili vaaditaan',
          description: '99 $/vuosi, maksetaan Applelle ravintolan virallisella yrityksellä',
        },
      },
    },
    ai_website: {
      title: 'Verkkosivutyökalun tilaus',
      subtitle_domain: 'Julkaise {{name}}n verkkosivu osoitteessa {{domain}}',
      features: {
        domain: {
          title: 'Verkkosivusi käytössä omalla verkkotunnuksellasi',
          description: 'Ravintolan brändätty verkkosivu',
        },
        ai: {
          title: 'Rakennettu ja päivitetty tekoälyllä',
          description: 'Luo sivuja, tekstiä ja kuvia ravintolalle minuuteissa',
        },
        ordering: {
          title: 'Tilaus ja varaukset sisäänrakennettuina',
          description: 'Vieraat tilaavat ja varaavat pöydän suoraan verkkosivulta',
        },
        pricing: {
          title: 'Ei käyttöönottomaksua',
          description: 'Yksi lisenssi per toimipiste, laskutetaan kuukausittain',
        },
      },
    },
    storefront: {
      title: 'Verkkosivutyökalun tilaus',
      subtitle_domain: 'Julkaise {{name}}n verkkosivu osoitteessa {{domain}}',
      features: {
        domain: {
          title: 'Verkkosivusi käytössä omalla verkkotunnuksellasi',
          description: 'Ravintolan brändätty verkkosivu',
        },
        ai: {
          title: 'Rakennettu ja päivitetty tekoälyllä',
          description: 'Luo sivuja, tekstiä ja kuvia ravintolalle minuuteissa',
        },
        ordering: {
          title: 'Tilaus ja varaukset sisäänrakennettuina',
          description: 'Vieraat tilaavat ja varaavat pöydän suoraan verkkosivulta',
        },
        pricing: {
          title: 'Ei käyttöönottomaksua',
          description: 'Yksi lisenssi per toimipiste, laskutetaan kuukausittain',
        },
      },
    },
  },
  payment_method: {
    label: 'Kumppanin maksutapa',
    on_file: 'Tallennettu kortti',
    pending_title: 'Vahvistetaan maksutapaasi',
    pending: 'Stripe vahvistaa vielä juuri lisäämääsi korttia. Tämä voi kestää hetken.',
    still_pending: 'Ei vielä valmis. Odota hetki ja tarkista uudelleen.',
    error: 'Maksulomaketta ei voitu avata. Yritä uudelleen.',
  },
  buttons: {
    close: 'Sulje',
    continue_to_payment: 'Jatka maksamiseen',
    start_trial: 'Aloita {{days}} päivän ilmainen kokeilu',
    subscribe: 'Aloita tilaus',
    continue: 'Jatka',
    change: 'Muuta',
    retry: 'Yritä uudelleen',
    check_again: 'Tarkista uudelleen',
    add_again: 'Lisää kortti uudelleen',
  },
};
